import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../../../app/GetProxy";
import { handleResponseCode } from "../../../../app/utilities/helpers";
const cookies = new Cookies();
const proxy = GetProxy();

export const gettoolsList = createAsyncThunk(
  "post/gettoolsList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/cmdb/api/v1/tools/getToolsListWithSearchAndPagination/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getJiraIssueTypeSave = createAsyncThunk(
  "post/getJiraIssueTypeSave",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/jira/api/v1/jiraConfig/mapAndUnMapForJiraIssueType`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const getJiraPrioritySave = createAsyncThunk(
  "post/getJiraPrioritySave",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/jira/api/v1/jiraConfig/mapAndUnMapForJiraPriority`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const getJiraStatusSave = createAsyncThunk(
  "post/getJiraStatusSave",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/jira/api/v1/jiraConfig/mapAndUnMapForJiraStatus`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const deleteJiracategory = createAsyncThunk(
  "Delete/deleteJiracategory",
  async ({ type, configId }) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");

    const typeMap = {
      issuetype: "deleteIssueTypeConfiguration",
      priority: "deletePriorityConfiguration",
      status: "deleteStatusConfiguration"
    };

    const normalizedType = type?.toLowerCase();
    const endpoint = `${proxy}/jira/api/v1/jiraConfig/${typeMap[normalizedType]}/${configId}`;

    try {
      const response = await fetch(endpoint, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        }
      });
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);


//Jira Config
export const getConfigJiraIssueTypeList = createAsyncThunk(
  "get/getConfigJiraIssueTypeList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    // const { id } = props;
    const res = await fetch(
      `${proxy}/jira/api/v1/jiraConfig/getIssueTypeMappedDateWithJiraConfig`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": Apitoken,
          USERNAME: User,
        },
      }
    ).then((resp) => resp.json());
    handleResponseCode(res);
    return res;
  }
);
export const getConfigJiraPriorityList = createAsyncThunk(
  "get/getConfigJiraPriorityList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    // const { id } = props;
    const res = await fetch(
      `${proxy}/jira/api/v1/jiraConfig/getPriorityMappedDateWithJiraConfig`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": Apitoken,
          USERNAME: User,
        },
      }
    ).then((resp) => resp.json());
    handleResponseCode(res);
    return res;
  }
);
export const getConfigJiraStatusList = createAsyncThunk(
  "get/getConfigJiraStatusList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    // const { id } = props;
    const res = await fetch(
      `${proxy}/jira/api/v1/jiraConfig/getStatusMappedDateWithJiraConfig`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": Apitoken,
          USERNAME: User,
        },
      }
    ).then((resp) => resp.json());
    handleResponseCode(res);
    return res;
  }
);

export const gettoolsCount = createAsyncThunk(
  "post/getDataCount",
  async (props) => {
    const { payload } = props;
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(`${proxy}/api/v1/tools/getToolsListCount`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getConfigToolsList = createAsyncThunk(
  "post/gettoolid",
  async (props) => {
    const { pageNumber, itemsPerPage, payload } = props;
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/cmdb/api/v1/tools/getToolsListWithSearchAndPagination/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
//Severity Configuration Roles
export const SeveritySLAConfigList = createAsyncThunk(
  "post/SeveritySLAConfigList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/tenable/api/v1/slaConfig/list/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const TypeConfiguration = createAsyncThunk(
  "post/TypeConfiguration",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/tenable/api/v1/vmTypeConfig/list/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const saveSeveritySLAConfig = createAsyncThunk(
  "post/saveSeveritySLAConfig",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/slaConfig/saveOrUpdate`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const SLAConfigHistory = createAsyncThunk(
  "post/SLAConfigHistory",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { slaConfigId, pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/tenable/api/v1/slaConfig/history/${slaConfigId}/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const CISSLAConfigHistory = createAsyncThunk(
  "post/CISSLAConfigHistory",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { slaConfigId, pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/tenable/api/v1/slaConfigForCISBenchMark/history/${slaConfigId}/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const VMTypeConfigHistory = createAsyncThunk(
  "post/VMTypeConfigHistory",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { slaConfigId, pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/tenable/api/v1/vmTypeConfig/history/${slaConfigId}/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const TypeConfigSaveUpdate = createAsyncThunk(
  "post/TypeConfigSaveUpdate",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/vmTypeConfig/saveOrUpdate`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
// CIS Benchmark SLA Configuration APIs
export const CISBenchmarkSLAConfigList = createAsyncThunk(
  "post/CISBenchmarkSLAConfigList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/tenable/api/v1/slaConfigForCISBenchMark/getSlaConfigTableListData/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const saveCISBenchmarkSLAConfig = createAsyncThunk(
  "post/saveCISBenchmarkSLAConfig",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/slaConfigForCISBenchMark/saveOrUpdateSLAConfiguration`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const deleteCISBenchmarkSLAConfig = createAsyncThunk(
  "Delete/deleteCISBenchmarkSLAConfig",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/slaConfigForCISBenchMark/deleteSLAConfiguration/${props}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const deleteSeveritySLAConfig = createAsyncThunk(
  "Delete/deleteSeveritySLAConfig",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/slaConfig/deleteSlaConfiguration/${props}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const deleteTypeVulnerabilityConfig = createAsyncThunk(
  "Delete/deleteTypeVulnerabilityConfig",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    console.log("props", props);
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/vmTypeConfig/deleteVulnerabilityTypeConfiguration/${props}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const FirstSeenOffsetConfigList = createAsyncThunk(
  "post/FirstSeenOffsetConfigList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");

    try {
      const { pageNumber, itemsPerPage, payload } = props;

      const response = await fetch(
        `${proxy}/tenable/api/v1/vmFirstSeenConfig/list/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );

      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const saveFirstSeenOffsetConfig = createAsyncThunk(
  "post/saveFirstSeenOffsetConfig",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/vmFirstSeenConfig/save`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

// CIS Benchmark First Seen Configuration APIs
export const CisBenchmarkFirstSeenConfigList = createAsyncThunk(
  "post/CisBenchmarkFirstSeenConfigList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");

    try {
      const { pageNumber, itemsPerPage, payload } = props;

      const response = await fetch(
        `${proxy}/tenable/api/v1/cisBenchmarkFirstSeenConfig/list/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );

      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const saveCisBenchmarkFirstSeenConfig = createAsyncThunk(
  "post/saveCisBenchmarkFirstSeenConfig",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/cisBenchmarkFirstSeenConfig/save`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const TypeNameList = createAsyncThunk(
  "get/TypeNameList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    console.log("props", props);
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/vmTypeConfig/getAllPluginFamilies`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const PriorityNameList = createAsyncThunk(
  "get/PriorityNameList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    console.log("props", props);
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/vmTypeConfig/priorityList`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const UpdatePriorityNameList = createAsyncThunk(
  "post/UpdatePriorityNameList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/vmTypeConfig/updatePriority`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const CisExclusionRuleHistory = createAsyncThunk(
  "post/CisExclusionRuleHistory",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { slaConfigId, pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/tenable/api/v1/cisBenchMark/ExclusionRule/history/${slaConfigId}/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const CisExclusionRuleList = createAsyncThunk(
  "post/CisExclusionRuleList",
  async (props, { rejectWithValue }) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;

      // Validate parameters
      if (typeof pageNumber !== 'number' || pageNumber < 0) {
        console.error("Invalid pageNumber:", pageNumber);
        return rejectWithValue({ message: "Invalid page number" });
      }
      if (typeof itemsPerPage !== 'number' || itemsPerPage <= 0) {
        console.error("Invalid itemsPerPage:", itemsPerPage);
        return rejectWithValue({ message: "Invalid items per page" });
      }

      const response = await fetch(
        `${proxy}/tenable/api/v1/cisBenchMark/ExclusionRule/list/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );

      handleResponseCode(response);
      const data = await response.json();

      if (!response.ok) {
        console.error("API Error - List Rules:", { status: response.status, data });
        return rejectWithValue(data || { message: "Failed to fetch rules" });
      }

      // Transform response to ensure correct structure
      let transformedData = {
        data: [],
        totalCount: 0
      };

      if (Array.isArray(data)) {
        // If API returns array directly
        transformedData.data = data;
        transformedData.totalCount = data.length;
      } else if (data?.data && Array.isArray(data.data)) {
        // If API returns { data: [...], ... }
        transformedData.data = data.data;
        transformedData.totalCount = data.totalElements || data.totalCount || data.data.length;
      } else if (data?.result && Array.isArray(data.result)) {
        // If API returns { result: [...], ... }
        transformedData.data = data.result;
        transformedData.totalCount = data.totalElements || data.count || data.result.length;
      } else if (typeof data === 'object' && data !== null) {
        // Try to find array in response
        const arrayKey = Object.keys(data).find(key => Array.isArray(data[key]));
        if (arrayKey) {
          transformedData.data = data[arrayKey];
          transformedData.totalCount = data.totalElements || data.totalCount || data.count || data[arrayKey].length;
        }
      }

      return transformedData;
    } catch (error) {
      console.error("Error in CisExclusionRuleList:", error);
      return rejectWithValue({ message: error.message || "Network error occurred" });
    }
  }
);

export const CisExclusionRuleAction = createAsyncThunk(
  "post/CisExclusionRuleAction",
  async (props, { rejectWithValue, signal }) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      // Validate payload
      if (!props) {
        console.error("No payload provided for CisExclusionRuleAction");
        return rejectWithValue({ message: "Invalid payload" });
      }

      const response = await fetch(
        `${proxy}/tenable/api/v1/cisBenchMark/ExclusionRule/saveOrUpdate`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
          signal: signal,
        }
      );

      handleResponseCode(response);
      const data = await response.json();

      if (!response.ok) {
        console.error("API Error - Save/Update Rule:", { status: response.status, data });
        return rejectWithValue(data || { message: "Failed to save/update rule" });
      }

      return data;
    } catch (error) {
      console.error("Error in CisExclusionRuleAction:", error);
      return rejectWithValue({ message: error.message || "Network error occurred" });
    }
  }
);

export const CisExclusionAuditFileList = createAsyncThunk(
  "get/CisExclusionAuditFileList",
  async (_, { rejectWithValue }) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/cisBenchMark/ExclusionRule/getAuditFileNames`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );

      handleResponseCode(response);
      const data = await response.json();

      if (!response.ok) {
        console.error("API Error - Get Audit Files:", { status: response.status, data });
        return rejectWithValue(data || { message: "Failed to fetch audit files" });
      }

      return data;
    } catch (error) {
      console.error("Error in CisExclusionAuditFileList:", error);
      return rejectWithValue({ message: error.message || "Network error occurred" });
    }
  }
);

export const CisExclusionRuleDelete = createAsyncThunk(
  "delete/CisExclusionRuleDelete",
  async (ruleId, { rejectWithValue }) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      // Validate rule ID
      if (!ruleId) {
        console.error("No rule ID provided for deletion");
        return rejectWithValue({ message: "Invalid rule ID" });
      }

      const response = await fetch(
        `${proxy}/tenable/api/v1/cisBenchMark/ExclusionRule/delete/${ruleId}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );

      handleResponseCode(response);
      const data = await response.json();

      if (!response.ok) {
        console.error("API Error - Delete Rule:", { status: response.status, data });
        return rejectWithValue(data || { message: "Failed to delete rule" });
      }

      return data;
    } catch (error) {
      console.error("Error in CisExclusionRuleDelete:", error);
      return rejectWithValue({ message: error.message || "Network error occurred" });
    }
  }
);

// Vulnerability Management Exclusion - Get Toggle Status
export const VulnerabilityExclusionToggleGet = createAsyncThunk(
  "get/VulnerabilityExclusionToggleGet",
  async (_, { rejectWithValue }) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/vulnerabilityExclusion/enableOrDisableExclusion`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );

      handleResponseCode(response);

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        data = { message: text };
      }

      if (!response.ok) {
        return rejectWithValue(data || { message: "Failed to fetch toggle status" });
      }

      return data;
    } catch (error) {
      return rejectWithValue({ message: error.message || "Network error occurred" });
    }
  }
);

// Vulnerability Management Exclusion - Get Latest Exclusion Status
export const GetLatestExclusionStatus = createAsyncThunk(
  "get/GetLatestExclusionStatus",
  async (_, { rejectWithValue }) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/vulnerabilityExclusion/getLatestExclusionStatus`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );

      handleResponseCode(response);

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        data = { status: false, message: text };
      }

      if (!response.ok) {
        return rejectWithValue(data || { message: "Failed to fetch exclusion status" });
      }

      return data;
    } catch (error) {
      return rejectWithValue({ message: error.message || "Network error occurred" });
    }
  }
);

// Vulnerability Management Exclusion - Toggle Enable/Disable
export const VulnerabilityExclusionToggleAction = createAsyncThunk(
  "post/VulnerabilityExclusionToggleAction",
  async (payload, { rejectWithValue }) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/tenable/api/v1/vulnerabilityExclusion/enableOrDisableExclusion`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );

      handleResponseCode(response);

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        data = { message: text };
      }

      if (!response.ok) {
        return rejectWithValue(data || { message: "Failed to update toggle status" });
      }

      return data;
    } catch (error) {
      return rejectWithValue({ message: error.message || "Network error occurred" });
    }
  }
);

// Vulnerability Management Exclusion - Get Excluded Findings List
export const VulnerabilityExclusionList = createAsyncThunk(
  "post/VulnerabilityExclusionList",
  async (props, { rejectWithValue }) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/tenable/api/v1/vulnerabilityExclusion/getExclusionTableListData/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );

      handleResponseCode(response);

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        if (!response.ok) {
          return rejectWithValue({ message: text || "Failed to fetch exclusion list" });
        }
        data = { message: text };
      }

      if (!response.ok) {
        return rejectWithValue(data || { message: "Failed to fetch exclusion list" });
      }

      let transformedData = {
        data: [],
        totalCount: 0,
      };

      if (Array.isArray(data)) {
        transformedData.data = data;
        transformedData.totalCount = data.length;
      } else if (data?.data && Array.isArray(data.data)) {
        transformedData.data = data.data;
        transformedData.totalCount = data.totalElements || data.totalCount || data.data.length;
      } else if (data?.result && Array.isArray(data.result)) {
        transformedData.data = data.result;
        transformedData.totalCount = data.totalElements || data.count || data.result.length;
      } else if (typeof data === 'object' && data !== null) {
        const arrayKey = Object.keys(data).find(key => Array.isArray(data[key]));
        if (arrayKey) {
          transformedData.data = data[arrayKey];
          transformedData.totalCount = data.totalElements || data.totalCount || data.count || data[arrayKey].length;
        }
      }

      transformedData.isExclusionEnabled =
        data?.isExclusionEnabled ?? data?.exclusionEnabled ?? data?.isEnabled ?? null;

      return transformedData;
    } catch (error) {
      return rejectWithValue({ message: error.message || "Network error occurred" });
    }
  }
);

const ToolSlice = createSlice({
  name: "ToolSlice",
  initialState: {
    resetData: [],
    getToolsListData: [],
    toolsCountData: [],
    toolsidDta: [],
    toolsLoading: false,
    toolscountLoading: false,
    error: [],

    //Save
    jiraIssuetypedata: [],
    jiraIssuetypeLoading: false,
    jiraPrioritydata: [],
    jiraPriorityLoading: false,
    jiraStatusdata: [],
    jiraStatusLoading: false,

    //Delete
    jiraDeletedata: [],
    jiraDeleteLoading: false,

    SeveritySLAConfigListData: [],
    SeveritySLAConfigListLoading: false,
    saveSeveritySLAConfigData: [],
    saveSeveritySLAConfigLoading: false,
    deleteSeveritySLAConfigData: [],
    deleteSeveritySLAConfigLoading: false,
    SLAConfigHistoryData: [],
    SLAConfigHistoryLoading: false,

    CISBenchmarkSLAConfigListData: [],
    CISBenchmarkSLAConfigListLoading: false,
    saveCISBenchmarkSLAConfigData: [],
    saveCISBenchmarkSLAConfigLoading: false,
    deleteCISBenchmarkSLAConfigData: [],
    deleteCISBenchmarkSLAConfigLoading: false,
    CISSLAConfigHistoryData: [],
    CISSLAConfigHistoryLoading: false,

    FirstSeenOffsetConfigListData: [],
    FirstSeenOffsetConfigListLoading: false,
    saveFirstSeenOffsetConfigData: [],
    saveFirstSeenOffsetConfigLoading: false,

    CisBenchmarkFirstSeenConfigListData: [],
    CisBenchmarkFirstSeenConfigListLoading: false,
    saveCisBenchmarkFirstSeenConfigData: [],
    saveCisBenchmarkFirstSeenConfigLoading: false,

    deleteTypeVulnerabilityConfigData: [],
    deleteTypeVulnerabilityConfigLoading: false,
    TypeNameListData: [],
    TypeNameListLoading: false,
    TypeConfigSaveUpdateData: [],
    TypeConfigSaveUpdateLoading: false,
    VMTypeConfigHistoryData: [],
    VMTypeConfigHistoryLoading: false,

    PriorityNameListLoading: false,
    PriorityNameListData: [],
    UpdatePriorityNameListLoading: false,
    UpdatePriorityNameListData: [],

    //Config Jira
    IssueTypeCatagorizedData: [],
    IssueTypeConfigJiraListLoading: false,
    PriorityCatagorizedData: [],
    PriorityConfigJiraListLoading: false,
    StatusCatagorizedData: [],
    StatusConfigJiraListLoading: false,

    CisExclusionRuleListData: [],
    CisExclusionRuleListLoading: false,
    CisExclusionRuleActionData: [],
    CisExclusionRuleActionLoading: false,
    CisExclusionAuditFileListData: [],
    CisExclusionAuditFileListLoading: false,
    CisExclusionRuleDeleteData: [],
    CisExclusionRuleDeleteLoading: false,
    CisExclusionRuleHistoryData: [],
    CisExclusionRuleHistoryLoading: false,
    CisExclusionRuleUpdatePriorityData: [],
    CisExclusionRuleUpdatePriorityLoading: false,

    // Vulnerability Management Exclusion
    VulnerabilityExclusionStatusData: null,
    VulnerabilityExclusionStatusLoading: false,
    VulnerabilityExclusionToggleData: null,
    VulnerabilityExclusionToggleStatus: false,
    VulnerabilityExclusionToggleActionLoading: false,
    VulnerabilityExclusionListData: null,
    VulnerabilityExclusionListLoading: false,
  },

  reducers: {
    setTools: {
      reducer(state, action) {
        state.resetData = action.payload;
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(gettoolsList.pending, (state, action) => {
        state.toolsLoading = true;
      })
      .addCase(gettoolsList.fulfilled, (state, action) => {
        state.getToolsListData = action.payload;
        state.toolsLoading = false;
      })
      .addCase(gettoolsList.rejected, (state, action) => {
        state.toolsLoading = false;
        state.getToolsListData = [];
        state.error = "Something went wrong";
      })

      .addCase(gettoolsCount.pending, (state, action) => {
        state.toolscountLoading = true;
      })
      .addCase(gettoolsCount.fulfilled, (state, action) => {
        state.toolsCountData = action.payload;
        state.toolscountLoading = false;
      })
      .addCase(gettoolsCount.rejected, (state, action) => {
        state.toolscountLoading = false;
        state.toolsCountData = [];
        state.error = "Something went wrong";
      })

      // save
      .addCase(getJiraIssueTypeSave.pending, (state, action) => {
        state.jiraIssuetypeLoading = true;
      })
      .addCase(getJiraIssueTypeSave.fulfilled, (state, action) => {
        state.jiraIssuetypedata = action.payload;
        state.jiraIssuetypeLoading = false;
      })
      .addCase(getJiraIssueTypeSave.rejected, (state, action) => {
        state.jiraIssuetypeLoading = false;
        state.jiraIssuetypedata = [];
        state.error = "Something went wrong";
      })

      .addCase(getJiraPrioritySave.pending, (state, action) => {
        state.jiraPriorityLoading = true;
      })
      .addCase(getJiraPrioritySave.fulfilled, (state, action) => {
        state.jiraPrioritydata = action.payload;
        state.jiraPriorityLoading = false;
      })
      .addCase(getJiraPrioritySave.rejected, (state, action) => {
        state.jiraPriorityLoading = false;
        state.jiraPrioritydata = [];
        state.error = "Something went wrong";
      })

      .addCase(getJiraStatusSave.pending, (state, action) => {
        state.jiraStatusLoading = true;
      })
      .addCase(getJiraStatusSave.fulfilled, (state, action) => {
        state.jiraStatusdata = action.payload;
        state.jiraStatusLoading = false;
      })
      .addCase(getJiraStatusSave.rejected, (state, action) => {
        state.jiraStatusLoading = false;
        state.jiraStatusdata = [];
        state.error = "Something went wrong";
      })
      ////

      //delete
      .addCase(deleteJiracategory.pending, (state, action) => {
        state.jiraDeleteLoading = true;
      })
      .addCase(deleteJiracategory.fulfilled, (state, action) => {
        state.jiraDeletedata = action.payload;
        state.jiraDeleteLoading = false;
      })
      .addCase(deleteJiracategory.rejected, (state, action) => {
        state.jiraDeleteLoading = false;
        state.jiraDeletedata = [];
        state.error = "Something went wrong";
      })

      //IssueType Config
      .addCase(getConfigJiraIssueTypeList.pending, (state, action) => {
        state.IssueTypeConfigJiraListLoading = true;
      })
      .addCase(getConfigJiraIssueTypeList.fulfilled, (state, action) => {
        state.IssueTypeCatagorizedData = action.payload;
        state.IssueTypeConfigJiraListLoading = false;
      })
      .addCase(getConfigJiraIssueTypeList.rejected, (state, action) => {
        state.IssueTypeConfigJiraListLoading = false;
        state.IssueTypeCatagorizedData = [];
        state.error = "Something went wrong";
      })
      // Priority config
      .addCase(getConfigJiraPriorityList.pending, (state, action) => {
        state.PriorityConfigJiraListLoading = true;
      })
      .addCase(getConfigJiraPriorityList.fulfilled, (state, action) => {
        state.PriorityCatagorizedData = action.payload;
        state.PriorityConfigJiraListLoading = false;
      })
      .addCase(getConfigJiraPriorityList.rejected, (state, action) => {
        state.PriorityConfigJiraListLoading = false;
        state.PriorityCatagorizedData = [];
        state.error = "Something went wrong";
      })
      // Status config
      .addCase(getConfigJiraStatusList.pending, (state, action) => {
        state.StatusConfigJiraListLoading = true;
      })
      .addCase(getConfigJiraStatusList.fulfilled, (state, action) => {
        state.StatusCatagorizedData = action.payload;
        state.StatusConfigJiraListLoading = false;
      })
      .addCase(getConfigJiraStatusList.rejected, (state, action) => {
        state.StatusConfigJiraListLoading = false;
        state.StatusCatagorizedData = [];
        state.error = "Something went wrong";
      })

      .addCase(getConfigToolsList.pending, (state, action) => {
        state.toolsLoading = true;
      })
      .addCase(getConfigToolsList.fulfilled, (state, action) => {
        state.getToolsListData = action.payload;
        state.toolsLoading = false;
      })
      .addCase(getConfigToolsList.rejected, (state, action) => {
        state.toolsLoading = false;
        state.getToolsListData = [{ data: [], totalCount: 0 }];
        state.error = "Something went wrong";
      })
      //Severity Configuration Roles
      .addCase(SeveritySLAConfigList.pending, (state, action) => {
        state.SeveritySLAConfigListLoading = true;
      })
      .addCase(SeveritySLAConfigList.fulfilled, (state, action) => {
        state.SeveritySLAConfigListData = action.payload;
        state.SeveritySLAConfigListLoading = false;
      })
      .addCase(SeveritySLAConfigList.rejected, (state, action) => {
        state.SeveritySLAConfigListLoading = false;
        state.SeveritySLAConfigListData = [];
        state.error = "Something went wrong";
      })

      .addCase(saveSeveritySLAConfig.pending, (state, action) => {
        state.saveSeveritySLAConfigLoading = true;
      })
      .addCase(saveSeveritySLAConfig.fulfilled, (state, action) => {
        state.saveSeveritySLAConfigData = action.payload;
        state.saveSeveritySLAConfigLoading = false;
      })
      .addCase(saveSeveritySLAConfig.rejected, (state, action) => {
        state.saveSeveritySLAConfigLoading = false;
        state.saveSeveritySLAConfigData = [];
        state.error = "Something went wrong";
      })

      .addCase(TypeConfigSaveUpdate.pending, (state, action) => {
        state.TypeConfigSaveUpdateLoading = true;
      })
      .addCase(TypeConfigSaveUpdate.fulfilled, (state, action) => {
        state.TypeConfigSaveUpdateData = action.payload;
        state.TypeConfigSaveUpdateLoading = false;
      })
      .addCase(TypeConfigSaveUpdate.rejected, (state, action) => {
        state.TypeConfigSaveUpdateLoading = false;
        state.TypeConfigSaveUpdateData = [];
        state.error = "Something went wrong";
      })

      .addCase(VMTypeConfigHistory.pending, (state, action) => {
        state.VMTypeConfigHistoryLoading = true;
      })
      .addCase(VMTypeConfigHistory.fulfilled, (state, action) => {
        state.VMTypeConfigHistoryData = action.payload;
        state.VMTypeConfigHistoryLoading = false;
      })
      .addCase(VMTypeConfigHistory.rejected, (state, action) => {
        state.VMTypeConfigHistoryLoading = false;
        state.VMTypeConfigHistoryData = [];
        state.error = "Something went wrong";
      })

      .addCase(deleteSeveritySLAConfig.pending, (state, action) => {
        state.deleteSeveritySLAConfigLoading = true;
      })
      .addCase(deleteSeveritySLAConfig.fulfilled, (state, action) => {
        state.deleteSeveritySLAConfigData = action.payload;
        state.deleteSeveritySLAConfigLoading = false;
      })
      .addCase(deleteSeveritySLAConfig.rejected, (state, action) => {
        state.deleteSeveritySLAConfigLoading = false;
        state.deleteSeveritySLAConfigData = [];
        state.error = "Something went wrong";
      })

      .addCase(SLAConfigHistory.pending, (state, action) => {
        state.SLAConfigHistoryLoading = true;
      })
      .addCase(SLAConfigHistory.fulfilled, (state, action) => {
        state.SLAConfigHistoryData = action.payload;
        state.SLAConfigHistoryLoading = false;
      })
      .addCase(SLAConfigHistory.rejected, (state, action) => {
        state.SLAConfigHistoryLoading = false;
        state.SLAConfigHistoryData = [];
        state.error = "Something went wrong";
      })

      .addCase(CISBenchmarkSLAConfigList.pending, (state, action) => {
        state.CISBenchmarkSLAConfigListLoading = true;
      })
      .addCase(CISBenchmarkSLAConfigList.fulfilled, (state, action) => {
        state.CISBenchmarkSLAConfigListData = action.payload;
        state.CISBenchmarkSLAConfigListLoading = false;
      })
      .addCase(CISBenchmarkSLAConfigList.rejected, (state, action) => {
        state.CISBenchmarkSLAConfigListLoading = false;
        state.CISBenchmarkSLAConfigListData = [];
        state.error = "Something went wrong";
      })

      .addCase(saveCISBenchmarkSLAConfig.pending, (state, action) => {
        state.saveCISBenchmarkSLAConfigLoading = true;
      })
      .addCase(saveCISBenchmarkSLAConfig.fulfilled, (state, action) => {
        state.saveCISBenchmarkSLAConfigData = action.payload;
        state.saveCISBenchmarkSLAConfigLoading = false;
      })
      .addCase(saveCISBenchmarkSLAConfig.rejected, (state, action) => {
        state.saveCISBenchmarkSLAConfigLoading = false;
        state.saveCISBenchmarkSLAConfigData = [];
        state.error = "Something went wrong";
      })

      .addCase(deleteCISBenchmarkSLAConfig.pending, (state, action) => {
        state.deleteCISBenchmarkSLAConfigLoading = true;
      })
      .addCase(deleteCISBenchmarkSLAConfig.fulfilled, (state, action) => {
        state.deleteCISBenchmarkSLAConfigData = action.payload;
        state.deleteCISBenchmarkSLAConfigLoading = false;
      })
      .addCase(deleteCISBenchmarkSLAConfig.rejected, (state, action) => {
        state.deleteCISBenchmarkSLAConfigLoading = false;
        state.deleteCISBenchmarkSLAConfigData = [];
        state.error = "Something went wrong";
      })

      .addCase(CISSLAConfigHistory.pending, (state, action) => {
        state.CISSLAConfigHistoryLoading = true;
      })
      .addCase(CISSLAConfigHistory.fulfilled, (state, action) => {
        state.CISSLAConfigHistoryData = action.payload;
        state.CISSLAConfigHistoryLoading = false;
      })
      .addCase(CISSLAConfigHistory.rejected, (state, action) => {
        state.CISSLAConfigHistoryLoading = false;
        state.CISSLAConfigHistoryData = [];
        state.error = "Something went wrong";
      })

      .addCase(FirstSeenOffsetConfigList.pending, (state, action) => {
        state.FirstSeenOffsetConfigListLoading = true;
      })
      .addCase(FirstSeenOffsetConfigList.fulfilled, (state, action) => {
        state.FirstSeenOffsetConfigListData = action.payload;
        state.FirstSeenOffsetConfigListLoading = false;
      })
      .addCase(FirstSeenOffsetConfigList.rejected, (state, action) => {
        state.FirstSeenOffsetConfigListLoading = false;
        state.FirstSeenOffsetConfigListData = [];
        state.error = "Something went wrong";
      })
      .addCase(saveFirstSeenOffsetConfig.pending, (state, action) => {
        state.saveFirstSeenOffsetConfigLoading = true;
      })
      .addCase(saveFirstSeenOffsetConfig.fulfilled, (state, action) => {
        state.saveFirstSeenOffsetConfigData = action.payload;
        state.saveFirstSeenOffsetConfigLoading = false;
      })
      .addCase(saveFirstSeenOffsetConfig.rejected, (state, action) => {
        state.saveFirstSeenOffsetConfigLoading = false;
        state.saveFirstSeenOffsetConfigData = [];
        state.error = "Something went wrong";
      })

      .addCase(CisBenchmarkFirstSeenConfigList.pending, (state, action) => {
        state.CisBenchmarkFirstSeenConfigListLoading = true;
      })
      .addCase(CisBenchmarkFirstSeenConfigList.fulfilled, (state, action) => {
        state.CisBenchmarkFirstSeenConfigListData = action.payload;
        state.CisBenchmarkFirstSeenConfigListLoading = false;
      })
      .addCase(CisBenchmarkFirstSeenConfigList.rejected, (state, action) => {
        state.CisBenchmarkFirstSeenConfigListLoading = false;
        state.CisBenchmarkFirstSeenConfigListData = [];
        state.error = "Something went wrong";
      })
      .addCase(saveCisBenchmarkFirstSeenConfig.pending, (state, action) => {
        state.saveCisBenchmarkFirstSeenConfigLoading = true;
      })
      .addCase(saveCisBenchmarkFirstSeenConfig.fulfilled, (state, action) => {
        state.saveCisBenchmarkFirstSeenConfigData = action.payload;
        state.saveCisBenchmarkFirstSeenConfigLoading = false;
      })
      .addCase(saveCisBenchmarkFirstSeenConfig.rejected, (state, action) => {
        state.saveCisBenchmarkFirstSeenConfigLoading = false;
        state.saveCisBenchmarkFirstSeenConfigData = [];
        state.error = "Something went wrong";
      })

      .addCase(deleteTypeVulnerabilityConfig.pending, (state, action) => {
        state.deleteTypeVulnerabilityConfigLoading = true;
      })
      .addCase(deleteTypeVulnerabilityConfig.fulfilled, (state, action) => {
        state.deleteTypeVulnerabilityConfigData = action.payload;
        state.deleteTypeVulnerabilityConfigLoading = false;
      })
      .addCase(deleteTypeVulnerabilityConfig.rejected, (state, action) => {
        state.deleteTypeVulnerabilityConfigLoading = false;
        state.deleteTypeVulnerabilityConfigData = [];
        state.error = "Something went wrong";
      })

      .addCase(TypeNameList.pending, (state, action) => {
        state.TypeNameListLoading = true;
      })
      .addCase(TypeNameList.fulfilled, (state, action) => {
        state.TypeNameListData = action.payload;
        state.TypeNameListLoading = false;
      })
      .addCase(TypeNameList.rejected, (state, action) => {
        state.TypeNameListLoading = false;
        state.TypeNameListData = [];

        state.error = "Something went wrong";
      })

      .addCase(PriorityNameList.pending, (state, action) => {
        state.PriorityNameListLoading = true;
      })
      .addCase(PriorityNameList.fulfilled, (state, action) => {
        state.PriorityNameListData = action.payload;
        state.PriorityNameListLoading = false;
      })
      .addCase(PriorityNameList.rejected, (state, action) => {
        state.PriorityNameListLoading = false;
        state.PriorityNameListData = [];
        state.error = "Something went wrong";
      })

      .addCase(UpdatePriorityNameList.pending, (state, action) => {
        state.UpdatePriorityNameListLoading = true;
      })
      .addCase(UpdatePriorityNameList.fulfilled, (state, action) => {
        state.UpdatePriorityNameListData = action.payload;
        state.UpdatePriorityNameListLoading = false;
      })
      .addCase(UpdatePriorityNameList.rejected, (state, action) => {
        state.UpdatePriorityNameListLoading = false;
        state.UpdatePriorityNameListData = [];
        state.error = "Something went wrong";
      })

      .addCase(CisExclusionRuleList.pending, (state, action) => {
        state.CisExclusionRuleListLoading = true;
        state.error = null;
      })
      .addCase(CisExclusionRuleList.fulfilled, (state, action) => {
        state.CisExclusionRuleListData = action.payload;
        state.CisExclusionRuleListLoading = false;
        state.error = null;
      })
      .addCase(CisExclusionRuleList.rejected, (state, action) => {
        state.CisExclusionRuleListLoading = false;
        state.CisExclusionRuleListData = [];
        state.error = action.payload?.message || "Failed to load exclusion rules";
        console.error("CisExclusionRuleList Error:", action.payload);
      })

      .addCase(CisExclusionRuleAction.pending, (state, action) => {
        state.CisExclusionRuleActionLoading = true;
        state.error = null;
      })
      .addCase(CisExclusionRuleAction.fulfilled, (state, action) => {
        state.CisExclusionRuleActionData = action.payload;
        state.CisExclusionRuleActionLoading = false;
        state.error = null;
      })
      .addCase(CisExclusionRuleAction.rejected, (state, action) => {
        state.CisExclusionRuleActionLoading = false;
        state.CisExclusionRuleActionData = [];
        state.error = action.payload?.message || "Failed to save/update rule";
        console.error("CisExclusionRuleAction Error:", action.payload);
      })
      .addCase(CisExclusionAuditFileList.pending, (state, action) => {
        state.CisExclusionAuditFileListLoading = true;
        state.error = null;
      })
      .addCase(CisExclusionAuditFileList.fulfilled, (state, action) => {
        state.CisExclusionAuditFileListData = action.payload;
        state.CisExclusionAuditFileListLoading = false;
        state.error = null;
      })
      .addCase(CisExclusionAuditFileList.rejected, (state, action) => {
        state.CisExclusionAuditFileListLoading = false;
        state.CisExclusionAuditFileListData = [];
        state.error = action.payload?.message || "Failed to load audit files";
        console.error("CisExclusionAuditFileList Error:", action.payload);
      })

      .addCase(CisExclusionRuleDelete.pending, (state, action) => {
        state.CisExclusionRuleDeleteLoading = true;
        state.error = null;
      })
      .addCase(CisExclusionRuleDelete.fulfilled, (state, action) => {
        state.CisExclusionRuleDeleteData = action.payload;
        state.CisExclusionRuleDeleteLoading = false;
        state.error = null;
      })
      .addCase(CisExclusionRuleDelete.rejected, (state, action) => {
        state.CisExclusionRuleDeleteLoading = false;
        state.CisExclusionRuleDeleteData = [];
        state.error = action.payload?.message || "Failed to delete rule";
        console.error("CisExclusionRuleDelete Error:", action.payload);
      })

      .addCase(CisExclusionRuleHistory.pending, (state, action) => {
        state.CisExclusionRuleHistoryLoading = true;
      })
      .addCase(CisExclusionRuleHistory.fulfilled, (state, action) => {
        state.CisExclusionRuleHistoryData = action.payload;
        state.CisExclusionRuleHistoryLoading = false;
      })
      .addCase(CisExclusionRuleHistory.rejected, (state, action) => {
        state.CisExclusionRuleHistoryLoading = false;
        state.CisExclusionRuleHistoryData = [];
        state.error = "Something went wrong";
      })

      // Vulnerability Management Exclusion - Toggle Action (Enable/Disable)
      .addCase(GetLatestExclusionStatus.pending, (state) => {
        state.VulnerabilityExclusionStatusLoading = true;
      })
      .addCase(GetLatestExclusionStatus.fulfilled, (state, action) => {
        state.VulnerabilityExclusionStatusData = action.payload;
        state.VulnerabilityExclusionStatusLoading = false;
      })
      .addCase(GetLatestExclusionStatus.rejected, (state) => {
        state.VulnerabilityExclusionStatusLoading = false;
        state.VulnerabilityExclusionStatusData = null;
      })

      .addCase(VulnerabilityExclusionToggleAction.pending, (state) => {
        state.VulnerabilityExclusionToggleActionLoading = true;
      })
      .addCase(VulnerabilityExclusionToggleAction.fulfilled, (state, action) => {
        state.VulnerabilityExclusionToggleActionLoading = false;
        state.VulnerabilityExclusionToggleStatus = action.meta.arg.enableOrDisable;
        // Keep list data in sync so re-mount reads the correct toggle value
        if (state.VulnerabilityExclusionListData && typeof state.VulnerabilityExclusionListData === 'object') {
          state.VulnerabilityExclusionListData.enableOrDisable = action.meta.arg.enableOrDisable;
        }
        // Keep exclusion status in sync with toggle action
        if (state.VulnerabilityExclusionStatusData) {
          state.VulnerabilityExclusionStatusData.status = action.meta.arg.enableOrDisable;
        }
      })
      .addCase(VulnerabilityExclusionToggleAction.rejected, (state, action) => {
        state.VulnerabilityExclusionToggleActionLoading = false;
        state.error = action.payload?.message || "Failed to toggle exclusion status";
      })

      // Vulnerability Management Exclusion - List
      .addCase(VulnerabilityExclusionList.pending, (state) => {
        state.VulnerabilityExclusionListLoading = true;
      })
      .addCase(VulnerabilityExclusionList.fulfilled, (state, action) => {
        state.VulnerabilityExclusionListData = action.payload;
        state.VulnerabilityExclusionListLoading = false;
        if (action.payload.isExclusionEnabled !== null && action.payload.isExclusionEnabled !== undefined) {
          state.VulnerabilityExclusionToggleStatus = action.payload.isExclusionEnabled;
        }
      })
      .addCase(VulnerabilityExclusionList.rejected, (state, action) => {
        state.VulnerabilityExclusionListLoading = false;
        state.VulnerabilityExclusionListData = null;
        state.error = action.payload?.message || "Failed to fetch exclusion list";
      });

  },
});

export const { setTools } = ToolSlice.actions;

export default ToolSlice.reducer;
